import { startSessionRestore } from '@shared/api';
import { APP_PATH, currentAppPath, toBrowserPath } from '@shared/config';
import { installChunkReloadRecovery } from '@shared/lib/chunk-reload';
import { buildLoginPath } from '@shared/lib/redirect';
import { onSessionExpired } from '@shared/session';

export interface StartBootOptions {
  navigate?: (path: string) => void;
  currentPath?: () => string;
}

/**
 * 엔트리(main.tsx)가 **첫 render 전에** 부른다.
 * 루트 컴포넌트의 effect 에서 시작하면 자식 effect 의 요청이 먼저 나간다.
 *
 * 세션 복원을 시작한다(기다리지 않는다 — 화면은 BootGate 가 막는다).
 */
export function startBoot(options: StartBootOptions = {}): () => void {
  const navigate =
    options.navigate ?? ((path: string) => window.location.assign(toBrowserPath(path)));
  const currentPath = options.currentPath ?? (() => currentAppPath());

  const uninstallChunkRecovery = installChunkReloadRecovery();

  // 갱신이 거절돼 세션이 끝났다 → 로그인으로(지금 주소를 redirect 로). 하드 네비게이션으로 메모리를 비운다.
  const offSessionExpired = onSessionExpired(() => {
    navigate(buildLoginPath(APP_PATH.login, currentPath()));
  });

  void startSessionRestore();

  return () => {
    uninstallChunkRecovery();
    offSessionExpired();
  };
}
